<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-1">
      <h2 class="m-0 font-roboto font-normal text-[14px] laptop:text-[16px] text-[#A084E8]">
        Quote Total:
      </h2>
      <h3 v-if="quoteSummary?.total_text != null" class="m-0 font-roboto font-bold text-[32px] laptop:text-[40px] leading-[1.2] text-[#333333]">
        ${{ $helper.formatAmountMode(quoteSummary.total, 1) }}.<span class="text-[25px]">{{
          $helper.formatAmountMode(quoteSummary.total, 2) }}</span>
      </h3>
    </div>
    <div class="flex items-center mobile:gap-2 tablet:gap-4">
      <button type="button"
        class="group flex items-center rounded-full gap-2 py-1.5 mobile:pl-2 tablet:pl-3 mobile:pr-1.5 tablet:pr-2 text-[14px] font-roboto font-normal h-[40px] mobile:text-[#fff] laptop:text-[#29C6CD] laptop:hover:text-[#fff] border-1 border-[#29C6CD] mobile:bg-[#29C6CD] laptop:bg-[#fff] hover:bg-[#29C6CD] transition duration-300"
        @click="viewQuoteClicked">
        Preview Quote
        <span
          class="h-[24px] w-[24px] transition duration-300 flex justify-center items-center rounded-full laptop:group-hover:bg-white mobile:bg-white laptop:bg-[#29C6CD] relative">
          <!-- Default Image -->
          <img :src="require(`@/assets/images/buttons-icons/start-quote.png`)" alt="icon"
            class="w-[16px] h-[16px] transition mobile:hidden laptop:block laptop:group-hover:hidden">

          <!-- Hover Color Version -->
          <div
            class="w-[16px] h-[16px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
            :style="{
              WebkitMask: `url(${require(`@/assets/images/buttons-icons/start-quote.png`)}) no-repeat center / contain`,
              mask: `url(${require(`@/assets/images/buttons-icons/start-quote.png`)}) no-repeat center / contain`,
              backgroundColor: '#29C6CD'
            }"></div>
        </span>
      </button>

      <button type="button"
        class="group flex items-center rounded-full gap-2 py-1.5 mobile:pl-2 tablet:pl-3 mobile:pr-1.5 tablet:pr-2 text-[14px] font-roboto font-normal h-[40px] mobile:text-[#fff] laptop:text-[#F67280] hover:text-[#fff] border-1 border-[#F67280] mobile:bg-[#F67280] laptop:bg-[#fff] laptop:hover:bg-[#F67280] transition duration-300"
        @click="editQuoteClicked">
        Edit Quote
        <span
          class="h-[24px] w-[24px] transition duration-300 text-[14px] flex justify-center items-center rounded-full laptop:group-hover:bg-white mobile:bg-white laptop:bg-[#F67280] relative">
          <!-- Default Image -->
          <img :src="require(`@/assets/images/buttons-icons/edit-quote.png`)" alt="icon"
            class="w-[16px] h-[16px] transition mobile:hidden laptop:block laptop:group-hover:hidden">
          <!-- Hover Color Version -->
          <div
            class="w-[16px] h-[16px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
            :style="{
              WebkitMask: `url(${require(`@/assets/images/buttons-icons/edit-quote.png`)}) no-repeat center / contain`,
              mask: `url(${require(`@/assets/images/buttons-icons/edit-quote.png`)}) no-repeat center / contain`,
              backgroundColor: '#F67280'
            }"></div>
        </span>
      </button>
    </div>

    <div v-if="quoteDetail.partner_info != null && quoteDetail.partner_info.is_tradecall_fee_applicable == 1"
      class="mt-[5px] flex flex-wrap justify-start items-baseline gap-1 font-roboto">
      <span class="text-[#F67280] text-[14px]">Important:</span>
      <h2 class="text-[14px] font-normal mb-0 text-[#666666]">
        <span class="font-bold text-[#000000]">
          ${{ $helper.formatAmount(quoteDetail.partner_info.tradecall_fee) }} </span>
        TradeCall Fee to be collected from {{ quoteDetail.consumer.full_name }}
      </h2>
    </div>

  </div>
  <!-- Modal -->
  <div id="exampleModal" ref="modalSummary" class="modal fade modal-lg" data-bs-backdrop="static"
    data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <QuoteModal :quote-summary="summary" @event="quoteClicked" />
    </div>
  </div>
  <div id="continueQuoteModal" ref="continueQuoteModal" class="modal fade fxModal fxConfirm" data-bs-backdrop="static" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body">
          <ConfirmLayout title="Submit Quote" button-text="Continue" bs-dismiss @close="closeQuoteContinueModal()"
            @confirm="updateSummary()">
            Are you sure you want to submit this quote?
          </ConfirmLayout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QuoteModal from "@/components/quote_modal/QuoteModal.vue";
import ConfirmLayout from "@/components/confirmDialog/ConfirmLayout.vue";
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";
import { param } from "jquery";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
const toast = useToast();

export default {
  components: {
    QuoteModal,
    ConfirmLayout,
  },

  props: ['no_of_units'],

  data() {
    return {
      summary: null,
    };
  },
  computed: {
    ...mapGetters([
      "storeQuoteData",
      "quoteDetail",
      "quoteSummary",
      "updateQuoteSummary",
    ]),

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    }
  },

  watch: {
    quoteSummary: function (data) {
      if (data != null) {
        this.summary = data;
        this.modal = new Modal(this.$refs.modalSummary);
        this.modal.show();
        disableScroll()
      }
    },

    updateQuoteSummary: function () {

      if ((this.$route.query.is_from_mobile ?? 0) == '1') {
        this.$router.push({
          path: `/success`, query: {
            flow: "uq-update",
            is_from_mobile: this.$route.query.is_from_mobile
          }
        });
      } else {
        toast.success("Quote has been updated successfully.");
        this.$router.push({ path: `/quote/detail/${this.quoteDetail.id}` });
      }

    },
  },

  mounted() {
    this.clearState();

    var params = {
      manual_quote_id: this.quoteDetail.id,
    };
    if (this.isPartnerQuote) {
      this.getQuoteSummary({
        url: "/manual-quote/partner/summary",
        params: params
      });
    } else {
      this.getQuoteSummary({
        url: "/manual-quote/summary/calculate",
        params: params
      });
    }

  },

  methods: {
    ...mapActions([
      "getQuoteSummary",
      "setCommponent",
      "clearState",
      "postQuoteSummary"
    ]),

    editQuoteClicked() {
      this.setCommponent("QuoteItems");
      window.location.reload()
    },

    viewQuoteClicked() {
      this.modal = new Modal(this.$refs.modalSummary);
      this.modal.show();
      disableScroll()
    },

    getPrice(ammount) {
      if (ammount != null) {
        ammount.replace("$", "");
      }
      return ammount;
    },
    updateSummary() {
      if (this.isPartnerQuote) {
        this.postQuoteSummary({
          url: "/manual-quote/partner/update",
          params: {
            manual_quote_id: this.quoteDetail.id,
            number_of_units: this.no_of_units
          }
        });
      } else {
        this.postQuoteSummary({
          url: "/manual-quote/submit-quote",
          params: {
            manual_quote_id: this.quoteDetail.id,
            number_of_units: this.no_of_units
          }
        });
      }
      this.modal.hide();
    },
    quoteClicked(opt) {
      if (opt == "submit") {
        disableScroll()
        this.modal = new Modal(this.$refs.continueQuoteModal);
        this.modal.show();
      } else {
        enableScroll()
        this.modal.hide();
      }
    },
    closeQuoteContinueModal() {
      this.modal.hide();
    },
  },
};
</script>
